<template>
    <div class="generate-ppt--filter-panel sticky-filter-panel">
        <div class="generate-ppt--filter-panel--content flex-grow-1 mx-4">

            <div class="row mb-3">
                <div class="filter-badge-container mt-3">
                    <label>Selected:</label>
                    <template v-if="applied_filters_list && applied_filters_list.length">
                        <template v-for="(filter, index) in applied_filters_list" :key="filter.filter_id + filter.filter_value">
                            <div v-if="filter && filter.filter_id !== -1" 
                                 class="badge" 
                                 :class="{'badge-with-btn': !filter.is_required}"
                                 @click.prevent="setActiveTab(filter.group_index)">
                                <span v-if="filter.filter_type === 'date_range'">
                                    {{filter.filter_label}}: {{ dateRangeDisplay(filter.filter_value) }}
                                </span>
                                <span v-else-if="filter.filter_type === 'month_range'">
                                    {{filter.filter_label}}: {{ monthRangeDisplay(filter.filter_value) }}
                                </span>
                                <span v-else-if="filter.filter_type === 'single_select'">
                                    {{filter.filter_label}} = "{{filter.filter_value}}"
                                </span>
                                <span v-else-if="filter.filter_type === 'multi_select' || filter.filter_type === 'month_picker' || filter.filter_type === 'array_single_select' || filter.filter_type === 'array_multi_select'">
                                    {{filter.filter_label}}{{ filter.filter_value.length >1 ? ' ('+filter.filter_value.length+')' : ' = "'+ filter.filter_value[0] +'"'}}
                                </span>
                                <span v-else-if="filter.filter_type === 'numeric_slider'">
                                    {{filter.filter_label}} between {{ filter.filter_value[0] }} and {{ filter.filter_value[1] }}
                                </span>
                                <button v-if="!filter.is_required" class="btn btn-xs p-0 ps-1" @click.prevent="removeAppliedFilter(filter, index)">
                                    <i class="fas fa-close"></i>
                                </button>
                            </div>
                            <div v-else-if="filter && filter.filter_id === -1"
                                 class="badge badge-secondary text-dark">
                                <span v-if="filter.filter_type === 'single_select'">
                                    {{filter.filter_label}} = "{{filter.filter_value}}"
                                </span>
                                <button class="btn btn-xs p-0 ps-1" @click.prevent="removeAppliedFilter(filter, index)">
                                    <i class="fas fa-close"></i>
                                </button>
                            </div>
                        </template>
                    </template>
                </div>
            </div>

            <div class="accordion" id="generate-ppt-filter-panel-accordion">
                <template v-for="(tab, index) in getNonEmptyFilterGroup" :key="index">
                    <div v-if="tab && tab.filter_group" class="accordion-item">
                        <h2 class="accordion-header">
                            <button class="accordion-button px-0" 
                                    :class="{ 'collapsed': active_tab_index !== index }" 
                                    type="button"
                                    :aria-expanded="active_tab_index === index" 
                                    :aria-controls="'collapse-' + index" 
                                    @click="setActiveTab(index)">
                                {{ tab.filter_group }}
                            </button>
                        </h2>
                        <div :id="'collapse-' + index"
                             class="accordion-collapse collapse"
                             :class="{ 'show': active_tab_index === index }">
                            <div class="accordion-body p-0">
                                <template v-for="(filter, filter_index) in tab.filters" :key="`${index}-${filter_index}-${filter && filter.id ? filter.id : filter_index}`">
                                    <div v-if="filter && ((filter.options && Array.isArray(filter.options) && filter.options.length) || filter.search_key != '')" class="mb-2">
                                        <advanced-filter-dropdown 
                                            :key="`filter-${index}-${filter_index}-${filter.id}`"
                                            :filter="filter" 
                                            :group_index="index" 
                                            :field_index="filter_index"  
                                            :active_group_index="active_tab_index" 
                                            :db_search="filter.db_search"
                                            @updateFilter="updateFilterInGroup"  
                                            @searchInLongOptionList="searchInLongOptionList">
                                        </advanced-filter-dropdown>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <!-- <div class="row sticky-bottom mx-0 py-2">
            <div class="w-100 d-flex flex-row justify-content-between align-items-center flex-nowrap gap-2">

                <div class="d-flex flex-row justify-content-end align-items-center gap-2">
                    <span>{{ filter_count }} {{(filter_count > 1 ? 'Filters': 'Filter')}} {{filter_count_label}}</span>
                </div>

                <div class="d-flex flex-row justify-content-end align-items-center flex-nowrap gap-2">
                    <button type="button" class="btn btn-secondary" @click.prevent="clearFilters()">
                        Clear All
                    </button>
                </div>

            </div>
        </div> -->
    </div>
</template>

<script>
    import { defineComponent } from 'vue';
    import Swal from 'sweetalert2';
    import { useNotifications } from '../../composables/useNotifications';
    import vSelect from "vue3-select";

    export default defineComponent({
        name: 'GeneratePresentationFilterPanel',
        components: {
            Swal,
            vSelect
        },
        setup() {
            const { showNotification } = useNotifications();
            return {
                showNotification
            };
        },
        props: {
            pages_selected: {
                type: Array,
                required: true
            },
            client: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                local_pages_selected: [],
                if_sticky: false,
                dimensional_filters_list: [],  // format: array of objects {filter_group: '', is_tab_active: boolean, filters: []}
                applied_filters_list: [],
                filter_errors: {},
                filter_count: 0,
                active_tab_index: 0
            };
        },
        mounted() {
            this.local_pages_selected = [...this.pages_selected];
            this.loadFilterGroups();
            this.getFilterCount();
        },
        computed: {
            getNonEmptyFilterGroup() {
                return this.dimensional_filters_list
                    .filter((group) => group && group.filters && group.filters.length !== 0)
                    .map((group) => ({
                        ...group,
                        filters: group.filters.filter((filter) => filter != null)
                    }))
                    .filter((group) => group.filters.length > 0);
            }
        },
        watch: {
            pages_selected: {
                handler(newVal) {
                    if (!newVal) return;
                    
                    // Prevent recursive updates by checking if the values are actually different
                    if (JSON.stringify(this.local_pages_selected) === JSON.stringify(newVal)) {
                        return;
                    }

                    this.local_pages_selected = [...newVal];
                    this.loadFilterGroups();
                    
                    // Use nextTick to ensure the DOM has updated before loading filter options
                    this.$nextTick(() => {
                        this.dimensional_filters_list.forEach((filter_group, group_index) => {
                            if (!filter_group || !filter_group.filters) return;
                            filter_group.filters.forEach((filter, filter_index) => {
                                if (!filter || !filter.options || filter.options.length === 0) {
                                    this.loadFilterOptions(group_index, filter_index);
                                }
                            });
                        });
                    });

                    // Use nextTick to ensure all filters are loaded before getting applied values
                    this.$nextTick(() => {
                        this.getAppliedFilterWithValue();
                        this.getFilterCount();
                    });
                },
                deep: true
            },
        },
        methods: {
            dateRangeDisplay(value) {
                if (value.start_date && value.end_date) {
                    return this.date(value.start_date) + ' - ' + this.date(value.end_date);
                } else if (value.start_date) {
                    return 'On or After ' + this.date(value.start_date);
                } else if (value.end_date) {
                    return 'Prior to ' + this.date(value.end_date);
                }
            },
            monthRangeDisplay(value) {
                if (!value) return '';
                
                if (value.start_date && value.end_date) {
                    return this.month(value.start_date) + ' - ' + this.month(value.end_date);
                } else if (value.start_date) {
                    return 'On or After ' + this.month(value.start_date);
                } else if (value.end_date) {
                    return 'Prior to ' + this.month(value.end_date);
                }
                return '';
            },
            setDefaultFilterValues(dimension_list) {
                dimension_list.forEach(dim => {
                    if ((dim.field_type !== 'date_range' && dim.field_type !== 'month_range' && dim.value && dim.value.length !== 0) ||
                        ((dim.field_type === 'date_range' || dim.field_type === 'month_range') && dim.value && (dim.value.start_date || dim.value.end_date))) {
                        // Do nothing
                    } else {
                        if (dim.field_type === "multi_select" || dim.field_type === "month_picker" || dim.field_type === "array_single_select" || dim.field_type === "array_multi_select") {
                            dim.value = [];
                        } else if (dim.field_type === "single_select") {
                            dim.value = "";
                        } else if (dim.field_type === "numeric_slider") {
                            dim.value = null;
                        } else if (dim.field_type === "date_range" || dim.field_type === "month_range") {
                            dim.value = {
                                'start_date': null,
                                'end_date': null
                            };
                        }
                    }
                });
                return dimension_list;
            },
            getAppliedFilterWithValue() {
                if (!this.dimensional_filters_list) return;
                
                const newAppliedFilters = [];
                this.dimensional_filters_list.forEach((group, group_i) => {
                    if (!group || !group.filters) return;
                    
                    group.filters.forEach((filter, filter_i) => {
                        if (!filter) return;

                        if (filter.value === undefined && (filter.field_type === 'multi_select' || filter.field_type === 'month_picker' || filter.field_type === 'array_single_select' || filter.field_type === 'array_multi_select')) {
                            filter.value = [];
                        }
                        if (filter.value === undefined && filter.field_type === 'single_select') {
                            filter.value = '';
                        }
                        if (filter.value && (filter.value.length > 0 ||
                            ((filter.field_type === 'date_range' || filter.field_type === 'month_range') && filter.value && (filter.value.end_date !== null || filter.value.start_date !== null)))) {

                            if (filter.field_type === "month_range") {
                                filter.value.start_date = filter.value.start_date ? moment(String(filter.value.start_date)).utc().format('YYYY-MM-DD') : null;
                                filter.value.end_date = filter.value.end_date ? moment(String(filter.value.end_date)).utc().format('YYYY-MM-DD') : null;
                            }

                            newAppliedFilters.push({
                                filter_id: filter.id,
                                filter_label: filter.label,
                                filter_value: filter.value,
                                filter_default_value: ((typeof filter.column === 'string' || filter.column instanceof String) && filter.column.indexOf('time_period.year_type') !== -1 ? this.client.default_reporting_period : filter.default_value),
                                filter_column_name: filter.column,
                                filter_type: filter.field_type,
                                is_required: filter.is_required,
                                group_index: group_i,
                                filter_index_in_group: filter_i
                            });
                        }
                    });
                });

                // Only update if there are actual changes
                if (JSON.stringify(this.applied_filters_list) !== JSON.stringify(newAppliedFilters)) {
                    this.applied_filters_list = newAppliedFilters;
                    this.getFilterCount();
                }
            },
            removeAppliedFilter(filter, filter_index) {
                this.applied_filters_list.splice(filter_index, 1);
                const currentFilter = this.dimensional_filters_list[filter.group_index].filters[filter.filter_index_in_group];
                
                if (currentFilter.field_type === 'single_select') {
                    currentFilter.value = '';
                } else if (currentFilter.field_type === 'numeric_slider') {
                    currentFilter.value = null;
                } else if (currentFilter.field_type === 'multi_select' || currentFilter.field_type === 'month_picker' || currentFilter.field_type === 'array_single_select' || currentFilter.field_type === 'array_multi_select') {
                    currentFilter.value = [];
                } else if (currentFilter.field_type === 'date_range' || currentFilter.field_type === 'month_range') {
                    currentFilter.value = {
                        start_date: null,
                        end_date: null
                    };
                }

                this.getFilterCount();
                this.showNotification({
                    text: 'Your filters have been updated!'
                });
            },
            handleScroll() {
                if (this.$refs.stickyDiv === null) return;
                const divTop = this.$refs.stickyDiv.getBoundingClientRect().top;
                this.if_sticky = divTop <= 0;
            },
            loadFilterGroups() {
                const dimension_list_temp = [];

                this.local_pages_selected.forEach(page => {
                    page.dimensions.forEach(dimension => {
                        if (dimension.disabled === undefined) {
                            dimension.disabled = true;
                        }
                        if (dimension.options === undefined) {
                            dimension.options = [];
                            dimension.db_search = false;
                        }

                        const index = dimension_list_temp.findIndex((dim) => dim.column === dimension.column);
                        if (index < 0) {
                            dimension_list_temp.push(dimension);
                        }
                    });
                });

                const processed_dimensions = this.setDefaultFilterValues(dimension_list_temp);
                const group_array = [];
                let group_name = null;
                let group_filters_temp = [];

                processed_dimensions.sort((a, b) => (a.filter_group > b.filter_group) ? 1 : -1);

                processed_dimensions.forEach(pf => {
                    if (pf.is_required) {
                        this.filter_errors[pf.label] = '';
                    }

                    if (group_name && pf.filter_group !== group_name) {
                        group_array.push({
                            filter_group: group_name,
                            filters: group_filters_temp
                        });
                        group_name = pf.filter_group;
                        group_filters_temp = [pf];
                    } else {
                        group_name = pf.filter_group;
                        group_filters_temp.push(pf);
                    }
                });

                group_array.push({
                    filter_group: group_name,
                    filters: group_filters_temp
                });

                this.dimensional_filters_list = group_array;
            },
            getMinMax(group_index, filter_index) {
                const filter = this.dimensional_filters_list[group_index].filters[filter_index];
                const data = {
                    source: 'data_blend',
                    data_source_id: this.pages_selected[0].data_blend.id,
                    client: this.client,
                    column: filter.column
                };

                window.axios.post('/api/bigquery/get_min_max', data)
                    .then(response => {
                        if (typeof response.data === 'object') {
                            filter.slider_min = response.data.min;
                            filter.slider_max = response.data.max;
                        } else {
                            const value = response.data.reduce((accumulator, current) => {
                                accumulator.push(parseInt(current.name));
                                return accumulator;
                            }, []);
                            filter.slider_min = Math.min(...value);
                            filter.slider_max = Math.max(...value);
                            filter.options = [];
                            filter.options.push(filter.slider_min);
                            filter.options.push(filter.slider_max);
                        }

                        if (filter.options && filter.options.length === 2 && !isNaN(filter.options[0]) && !isNaN(filter.options[1])) {
                            if (filter.options[0] < filter.slider_min) {
                                filter.slider_min = filter.options[0];
                            }
                            if (filter.options[1] > filter.slider_max) {
                                filter.slider_max = filter.options[1];
                            }
                        }

                        if (this.dimensional_filters_list[group_index] && this.dimensional_filters_list[group_index].filters[filter_index]) {
                            this.dimensional_filters_list[group_index].filters[filter_index].disabled = false;
                            this.dimensional_filters_list[group_index].filters[filter_index] = JSON.parse(JSON.stringify(filter));
                        }
                    });
            },
            loadFilterOptions(group_index, filter_index) {
                const filter = this.dimensional_filters_list[group_index].filters[filter_index];
                if (!filter || filter.column === null) {
                    if (filter) {
                        filter.options = [];
                        filter.db_search = false;
                    }
                    return;
                }
                if (filter.field_type === 'numeric_slider') {
                    this.getMinMax(group_index, filter_index);
                    return;
                }

                const data = {
                    client: this.client,
                    source: 'data_blend',
                    column: filter.column,
                    limit: 1000,
                    data_source_id: this.pages_selected[0].data_blend.id,
                    staging_table: false
                };

                window.axios.post('/api/bigquery/get_samples', data)
                    .then(response => {
                        if (!response.data || !response.data.samples) {
                            if (this.dimensional_filters_list[group_index] !== null) {
                                this.dimensional_filters_list[group_index].filters.splice(filter_index, 1);
                            }
                            return;
                        }

                        const db_values = [];
                        const samples = response.data.samples.filter(sample => 
                            sample && sample.name !== null && sample.name !== 'Donation'
                        );

                        if (filter.field_type === 'single_select' || filter.field_type === 'multi_select' || filter.field_type === 'month_picker' || filter.field_type === 'array_single_select' || filter.field_type === 'array_multi_select') {
                            db_values.push(...samples.map(sample => sample.name));
                        }

                        if (filter.field_type === 'month_picker') {
                            const monthOrder = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                            db_values.sort((a, b) => monthOrder.indexOf(a) > monthOrder.indexOf(b) ? 1 : -1);
                        } else {
                            db_values.sort((a, b) => (a.name > b.name) ? 1 : -1);
                        }

                        if (db_values.length === 0) {
                            if (this.dimensional_filters_list[group_index] !== null) {
                                this.dimensional_filters_list[group_index].filters.splice(filter_index, 1);
                            }
                        } else {
                            filter.options = db_values;
                            filter.disabled = false;
                            filter.db_search = (db_values.length >= 999);
                            if (this.dimensional_filters_list[group_index] !== null) {
                                this.dimensional_filters_list[group_index].filters[filter_index] = JSON.parse(JSON.stringify(filter));
                            }
                        }
                    })
                    .catch(error => {
                        if (filter) {
                            filter.options = [];
                            filter.disabled = false;
                            filter.db_search = false;
                        }
                    });
            },
            checkIfDropdownsLoaded() {
                return this.dimensional_filters_list.every(group => 
                    group.filters.every(filter => filter.disabled !== true)
                );
            },
            setActiveTab(index) {
                this.active_tab_index = this.active_tab_index === index ? -1 : index;
            },
            getTileClass(filter, option) {
                if (filter.field_type === 'tile-single-select' && filter.value[0] && filter.value[0].id === option.id) {
                    return 'tile-selected';
                }
                return '';
            },
            selectOption(group_index, filter_index, option) {
                const filter = this.dimensional_filters_list[group_index].filters[filter_index];
                if (filter.field_type === 'tile-single-select') {
                    filter.value = [option];
                } else {
                    filter.value.push(option);
                }
                this.getFilterCount();
            },
            updateFilterInGroup(filter_details) {
                if (!filter_details || !this.dimensional_filters_list[filter_details.group_index]) return;
                
                const filter = this.dimensional_filters_list[filter_details.group_index].filters[filter_details.field_index];
                if (!filter) return;

                // Only update if the value has actually changed
                if (JSON.stringify(filter.value) !== JSON.stringify(filter_details.filter_value)) {
                    filter.value = filter_details.filter_value;
                    
                    this.showNotification({
                        text: 'Your filters have been updated!'
                    });

                    this.$nextTick(() => {
                        this.getAppliedFilterWithValue();
                    });
                }
            },
            searchInLongOptionList(search_details) {
                const filter = this.dimensional_filters_list[search_details.group_index].filters[search_details.field_index];
                const data = {
                    client: this.client,
                    source: 'data_blend',
                    column: filter.column,
                    limit: 1000,
                    data_source_id: this.pages_selected[0].data_blend.id,
                    staging_table: false,
                    search: search_details.search_key
                };

                window.axios.post('/api/bigquery/get_samples', data)
                    .then(response => {
                        const db_values = [];

                        for (let i = response.data.samples.length - 1; i >= 0; i--) {
                            if (response.data.samples[i].name === null) {
                                response.data.samples.splice(i, 1);
                            } else {
                                if (filter.field_type === 'single_select' || filter.field_type === 'multi_select' || filter.field_type === 'month_picker' || filter.field_type === 'array_single_select' || filter.field_type === 'array_multi_select') {
                                    db_values.push(response.data.samples[i].name);
                                }
                            }
                        }

                    // Update the filter object directly - Vue 3's reactivity system will handle this
                    this.dimensional_filters_list[search_details.group_index].filters[search_details.field_index] = {
                        ...filter,
                        options: db_values,
                        disabled: false,
                        search_key: search_details.search_key
                    };
                    
                    this.$forceUpdate();
                });
            },
            getFilterCount() {
                if (!this.dimensional_filters_list) return;
                
                let filter_count_temp = 0;

                this.dimensional_filters_list.forEach((filter_group) => {
                    if (!filter_group || !filter_group.filters) return;
                    
                    filter_group.filters.forEach((filter) => {
                        if (!filter) return;
                        
                        if ((filter.field_type === 'date_range' || filter.field_type === 'month_range') && filter.value && (filter.value.start_date || filter.value.end_date)) {
                            filter_count_temp++;
                        } else if (filter.field_type !== 'date_range' && filter.field_type !== 'month_range' && filter.value && filter.value.length !== 0) {
                            filter_count_temp++;
                        }
                    });
                });

                // Only emit if the count has changed
                if (this.filter_count !== filter_count_temp) {
                    this.filter_count = filter_count_temp;
                    this.$emit('updateFilterCount', filter_count_temp);
                    this.$emit('updateFilters', this.applied_filters_list);
                }
            }
        }
    });
</script>
